import Vue from 'vue/dist/vue.common';
import { apolloProvider } from "../vue-apollo-init";
import gql from 'graphql-tag'
import _ from 'lodash';
import postQuery from './../gql/post_query.graphql';

export class Page_Content_Slider {
    constructor(){
        this.vue_element = false;        
    }
    init(){
        let store = window.store;
        let router = window.router;
        
        this.vue_element = new Vue({
            apolloProvider,
            apollo: {
              slider_article_item: {
                query: postQuery,
                update (data) {
                  if(data.post){
                    return {...data.post, 'element_id': 'main-right-slider' };
                  } else {
                    return {...data.page, 'element_id': 'main-right-slider' };
                  }
                },
                variables() {
                  return {
                    //post_id: store.state.post_id
                    post_uri: store.state.slider_post_uri
                  }
                },
              }
            },
            el: '#main-right-slider',
            template: '#page-template-slider',
            data: store.state,
            updated: function () {
              this.$nextTick(function () {
                router.updatePageLinks();
                if(store.state.firstCallSlider){
                  //console.log('firstcallslider');
                  store.setFirstCallSlider(false);
                } else {
                  //console.log('second & more call slider');
                  document.getElementById('main-right-container').classList.remove('hide');
                  //
                  document.getElementById('main-right-slider').classList.add('active');
                  window.setTimeout(function(){
                    document.getElementById('menu__wrapper').classList.remove('active');
                    store.setPostURIAction(store.state.slider_post_uri);
                  }, 800);
                }
              })
            },
            methods: {
              open_menu: function (event) {
                document.getElementById('menu__wrapper').classList.add('active');
                document.getElementById('main-right-container').classList.remove('hide');
              },
              on_click_close: function (event) {
                document.getElementById('main-right-container').classList.add('hide');
                this.scroll_to_top();
              },
              scroll_to_top: function (event) {
                window.scrollTo(0,0);
                document.getElementById('main-right-slider').scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              },
              onScroll: _.throttle(() => {                
                let mainContainerRight = document.getElementById('main-right-slider');
                let scrollPosition = Math.round(mainContainerRight.scrollTop);
                let clientHeight = Math.round(mainContainerRight.clientHeight);
                let scrollHeight = Math.round(mainContainerRight.scrollHeight);
                let scrollToTopElementSlider = document.getElementById('scroll-to-top-right-slider');

                scrollToTopElementSlider.classList.add('active');
                if (scrollPosition > 100){
                  scrollToTopElementSlider.classList.add('active');
                } else {
                  scrollToTopElementSlider.classList.remove('active');
                }
        
                scrollToTopElementSlider.style.top = (scrollPosition + (clientHeight * 0.75 )) + 'px';
        
                }, 200, { 'leading': true }),
              swipeHandler: function(direction){
                document.getElementById('main-right-container').classList.add('hide');
                window.setTimeout(this.scroll_to_top, 800);
              },
              set_tag(tag_id, tag_title) {
                store.setTag({tag_id: tag_id, tag_title: tag_title});
              },
              is_tag_active(tag_id, tag_title) {
                if(this?.posts_tags?.tag_id){
                  return tag_id == this.posts_tags.tag_id;
                } else {
                  return false;
                }
              },
              set_cat(cat_id, cat_type){
                store.setCat(cat_id, cat_type);
              },
              is_cat_active(cat_id, cat_type) {
                return _.some(this.posts_cats, {taxonomy: cat_type, terms: cat_id})
              }              
              /*onMoving: function(touch_event){
                //console.log(touch_event);
                //console.log(this.$el.clientWidth);
                let mainRightSlider = document.getElementById('main-right-slider');
                let lastPosX = this.lastPosX || 0;
                let newPosX = touch_event.changedTouches[0].clientX;
                let SliderPosX = mainRightSlider.style.left || 0;
                SliderPosX = parseInt(SliderPosX) + (newPosX - lastPosX);
                mainRightSlider.style.left = SliderPosX + 'px' ;
                console.log('diff: ' + (newPosX - lastPosX));
                this.lastPosX = newPosX;
                if(SliderPosX > (this.$el.clientWidth * 0.5)){
                  console.log('bust');
                }

              }*/
            },
            computed: {
              orderedPages: function () {
                return _.orderBy(this?.article_item?.children?.nodes, 'menuOrder')
              },
              orderedParentPages: function () {
                return _.orderBy(this?.article_item?.parent?.node?.children?.nodes, 'menuOrder')
              }
            }

          });
    }
}